import React from 'react';
import {
    Dashboard as DashboardIcon,
    People as PeopleIcon,
    DirectionsCar as CarIcon,
    Settings as SettingsIcon,
    AccountBalanceWallet as CreditCardIcon,
    Person as UserCircleIcon,
    Layers as LayersIcon,
    Notifications as BellIcon,
    Send as SendIcon,
    SupportAgent as SupportAgentIcon,
    ChatBubbleOutline as ChatIcon,
    Star as StarIcon,
    Map as MapPinIcon,
    DirectionsBus as BusIcon,
    PersonAdd as ReferralIcon,
    LocalOffer as CouponIcon,
    CancelOutlined as CancelIcon,
    Build as BuildIcon,
    TrendingUp as GrowthIcon,
    CardMembership as PassIcon,
    Schedule as ScheduleIcon,
    TravelExplore as TravelExploreIcon,
    Receipt as ReceiptIcon,
    Tune as TuneIcon,
    Gavel as GavelIcon,
    ViewCarousel as ViewCarouselIcon,
    NotificationImportant as NoticeIcon,
    ToggleOn as ToggleOnIcon,
    PriceChange as PriceChangeIcon,
    Rule as RuleIcon,
    Celebration as CelebrationIcon,
    Payments as PaymentsIcon,
    Campaign as CampaignIcon,
    Insights as InsightsIcon,
    History as HistoryIcon,
    ManageAccounts as ManageAccountsIcon,
} from '@mui/icons-material';

/* ─── Menu item type ─────────────────────────────────────────────────── */
export interface MenuItemDef {
    text: string;
    icon: React.ReactNode;
    path: string;
    category: string;
}

/* ─── All sidebar menu items ─────────────────────────────────────────── */
export const ALL_MENU_ITEMS: MenuItemDef[] = [
    { text: 'Dashboard', icon: <DashboardIcon />, path: '/', category: 'overview' },
    { text: 'Analytics', icon: <GrowthIcon />, path: '/analytics', category: 'overview' },
    { text: 'Routes & Stops', icon: <BusIcon />, path: '/commute-routes', category: 'rides' },
    { text: 'Daily Trips', icon: <BusIcon />, path: '/commute-trips', category: 'rides' },
    { text: 'Waitlist Requests', icon: <BusIcon />, path: '/commute-waitlist', category: 'rides' },
    { text: 'Requests & Demand', icon: <GrowthIcon />, path: '/requests-demand', category: 'rides' },
    { text: 'Ride Monitoring', icon: <CarIcon />, path: '/rides', category: 'rides' },
    { text: 'Scheduled Rides', icon: <ScheduleIcon />, path: '/scheduled-rides', category: 'rides' },
    { text: 'Commute Bookings', icon: <BusIcon />, path: '/commute-bookings', category: 'rides' },
    { text: 'Monthly Passes', icon: <PassIcon />, path: '/commute-passes', category: 'rides' },
    { text: 'Cancellations', icon: <CancelIcon />, path: '/cancellations', category: 'rides' },
    { text: 'Drivers', icon: <PeopleIcon />, path: '/drivers', category: 'fleet' },
    { text: 'Driver Notices', icon: <NoticeIcon />, path: '/driver-notices', category: 'fleet' },
    { text: 'Driver Salary', icon: <CreditCardIcon />, path: '/commute-salary-config', category: 'fleet' },
    { text: 'Attendance', icon: <ScheduleIcon />, path: '/commute-attendance', category: 'fleet' },
    { text: 'Penalties', icon: <CancelIcon />, path: '/commute-penalties', category: 'fleet' },
    { text: 'Incentive Rules', icon: <GrowthIcon />, path: '/commute-incentive-rules', category: 'fleet' },
    { text: 'Payout Batches', icon: <ReceiptIcon />, path: '/commute-payout-batches', category: 'fleet' },
    { text: 'Earnings Ledger', icon: <ReceiptIcon />, path: '/commute-driver-ledger', category: 'fleet' },
    { text: 'Vehicles', icon: <CarIcon />, path: '/vehicles', category: 'fleet' },
    { text: 'Vehicle Categories', icon: <LayersIcon />, path: '/vehicle-categories', category: 'fleet' },
    { text: 'Geofencing', icon: <MapPinIcon />, path: '/geofencing', category: 'fleet' },
    { text: 'Services On/Off', icon: <ToggleOnIcon />, path: '/services', category: 'services' },
    { text: 'City Rental — Packages', icon: <PriceChangeIcon />, path: '/rental-packages', category: 'services' },
    { text: 'City Rental — Add-ons & Cancellation', icon: <RuleIcon />, path: '/rental-rules', category: 'services' },
    { text: 'City Rental — Surcharges', icon: <TuneIcon />, path: '/rental-surcharges', category: 'services' },
    { text: 'City Rental — Disputes', icon: <ReceiptIcon />, path: '/rental-disputes', category: 'services' },
    { text: 'Outstation & Intercity — Rates, Taxes & Rules', icon: <TravelExploreIcon />, path: '/outstation-settings', category: 'services' },
    { text: 'Outstation & Intercity — Bookings & Charges', icon: <CarIcon />, path: '/outstation-bookings', category: 'services' },
    { text: 'User Management', icon: <UserCircleIcon />, path: '/users', category: 'users' },
    { text: 'Support Tickets', icon: <SupportAgentIcon />, path: '/tickets', category: 'users' },
    { text: 'Quick Chat', icon: <ChatIcon />, path: '/quick-chat-conversations', category: 'users' },
    { text: 'Ratings', icon: <StarIcon />, path: '/ratings', category: 'users' },
    { text: 'Transactions', icon: <CreditCardIcon />, path: '/transactions', category: 'finance' },
    { text: 'Wallet', icon: <CreditCardIcon />, path: '/wallet', category: 'finance' },
    { text: 'Withdrawals', icon: <CreditCardIcon />, path: '/withdrawals', category: 'finance' },
    { text: 'Marketing Dashboard', icon: <InsightsIcon />, path: '/marketing', category: 'growth' },
    { text: 'Website Leads', icon: <CampaignIcon />, path: '/website-leads', category: 'growth' },
    { text: 'Referrals', icon: <ReferralIcon />, path: '/referrals', category: 'growth' },
    { text: 'Referral Settings', icon: <TuneIcon />, path: '/referral-settings', category: 'growth' },
    { text: 'Coupons', icon: <CouponIcon />, path: '/coupons', category: 'growth' },
    { text: 'Promo Banners', icon: <ViewCarouselIcon />, path: '/promo-banners', category: 'growth' },
    { text: 'Notifications', icon: <BellIcon />, path: '/notifications', category: 'system' },
    { text: 'Send Notification', icon: <SendIcon />, path: '/send-notification', category: 'system' },
    { text: 'Maintenance', icon: <BuildIcon />, path: '/maintenance', category: 'system' },
    { text: 'Settings', icon: <SettingsIcon />, path: '/settings', category: 'system' },
    { text: 'Terms & Conditions', icon: <GavelIcon />, path: '/terms-editor', category: 'system' },
    { text: 'Team & Logins', icon: <ManageAccountsIcon />, path: '/team', category: 'system' },
    { text: 'Activity Log', icon: <HistoryIcon />, path: '/activity-log', category: 'system' },
    { text: 'Bookings', icon: <CelebrationIcon />, path: '/wedding-bookings', category: 'wedding' },
    { text: 'Availability', icon: <ScheduleIcon />, path: '/wedding-availability', category: 'wedding' },
    { text: 'Vehicle Pricing', icon: <PaymentsIcon />, path: '/wedding-pricing', category: 'wedding' },
    { text: 'Configuration', icon: <TuneIcon />, path: '/wedding-settings', category: 'wedding' },
    { text: 'Bookings', icon: <BusIcon />, path: '/coach-bookings', category: 'coach' },
    { text: 'Operations', icon: <ReceiptIcon />, path: '/coach-operations', category: 'coach' },
    { text: 'Vehicle Listings', icon: <BusIcon />, path: '/coach-listings', category: 'coach' },
    { text: 'Configuration', icon: <TuneIcon />, path: '/coach-settings', category: 'coach' },
    { text: 'Legacy Bookings (Tempo/Bus/Urbania)', icon: <BusIcon />, path: '/vehicle-booking-requests', category: 'coach' },
    { text: 'Bills', icon: <ReceiptIcon />, path: '/bills', category: 'billing' },
    { text: 'Customers', icon: <UserCircleIcon />, path: '/billing-customers', category: 'billing' },
    { text: 'Saved Items', icon: <LayersIcon />, path: '/billing-items', category: 'billing' },
    { text: 'Billing Settings', icon: <TuneIcon />, path: '/billing-settings', category: 'billing' },
];

/* ─── Category definitions ───────────────────────────────────────────── */
export interface CategoryDef {
    key: string;
    label: string;
    subtitle: string;
    icon: React.ReactNode;
    gradient: string;
    iconBg: string;
    iconColor: string;
    firstRoute: string;
    itemCount: number;
}

const countItems = (key: string) => ALL_MENU_ITEMS.filter(m => m.category === key).length;

export const CATEGORIES: CategoryDef[] = [
    { key: 'overview', label: 'Overview', subtitle: 'Dashboard & Analytics', icon: <DashboardIcon sx={{ fontSize: 32 }} />, gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', iconBg: '#ede9fe', iconColor: '#7c3aed', firstRoute: '/', itemCount: 0 },
    { key: 'rides', label: 'Ride Operations', subtitle: 'Commute, Monitoring & Cancellations', icon: <CarIcon sx={{ fontSize: 32 }} />, gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', iconBg: '#fce7f3', iconColor: '#db2777', firstRoute: '/commute-routes', itemCount: 0 },
    { key: 'fleet', label: 'Fleet & Drivers', subtitle: 'Drivers, Vehicles, Categories & Zones', icon: <PeopleIcon sx={{ fontSize: 32 }} />, gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', iconBg: '#dbeafe', iconColor: '#2563eb', firstRoute: '/drivers', itemCount: 0 },
    { key: 'services', label: 'Services & Rates', subtitle: 'On/off, rates & rules: City Rental, Coach, Outstation, Intercity, Wedding', icon: <ToggleOnIcon sx={{ fontSize: 32 }} />, gradient: 'linear-gradient(135deg, #f7971e 0%, #ffd200 100%)', iconBg: '#fef3c7', iconColor: '#b45309', firstRoute: '/services', itemCount: 0 },
    { key: 'users', label: 'Users & Support', subtitle: 'Customers, Tickets & Ratings', icon: <UserCircleIcon sx={{ fontSize: 32 }} />, gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)', iconBg: '#d1fae5', iconColor: '#059669', firstRoute: '/users', itemCount: 0 },
    { key: 'finance', label: 'Finance', subtitle: 'Transactions, Wallet & Withdrawals', icon: <CreditCardIcon sx={{ fontSize: 32 }} />, gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', iconBg: '#fef3c7', iconColor: '#d97706', firstRoute: '/transactions', itemCount: 0 },
    { key: 'growth', label: 'Growth & Marketing', subtitle: 'Marketing dashboard, Website leads, Referrals, Coupons & Banners', icon: <GrowthIcon sx={{ fontSize: 32 }} />, gradient: 'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)', iconBg: '#f3e8ff', iconColor: '#9333ea', firstRoute: '/marketing', itemCount: 0 },
    { key: 'system', label: 'System & Admin', subtitle: 'Notifications, Maintenance, Settings & Activity log', icon: <SettingsIcon sx={{ fontSize: 32 }} />, gradient: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)', iconBg: '#ffedd5', iconColor: '#ea580c', firstRoute: '/notifications', itemCount: 0 },
    { key: 'wedding', label: 'Wedding Car Hire', subtitle: 'Bookings & Configuration', icon: <CelebrationIcon sx={{ fontSize: 32 }} />, gradient: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)', iconBg: '#ffedd5', iconColor: '#c2410c', firstRoute: '/wedding-bookings', itemCount: 0 },
    { key: 'coach', label: 'Coach & Group Travel', subtitle: 'Bookings, Operations, Listings & Configuration', icon: <BusIcon sx={{ fontSize: 32 }} />, gradient: 'linear-gradient(135deg, #5b86e5 0%, #36d1dc 100%)', iconBg: '#e0f2fe', iconColor: '#0369a1', firstRoute: '/coach-bookings', itemCount: 0 },
    { key: 'billing', label: 'Billing', subtitle: 'Tax Invoices, Bills of Supply & PDFs', icon: <ReceiptIcon sx={{ fontSize: 32 }} />, gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)', iconBg: '#dcfce7', iconColor: '#15803d', firstRoute: '/bills', itemCount: 0 },
];

/* Sidebar counts come from the menu itself so they can never drift from what is actually listed. */
CATEGORIES.forEach(c => { c.itemCount = countItems(c.key); });

/** Resolve which menu item (and therefore which category) a given route path belongs to. */
export const findMenuItemForPath = (pathname: string): MenuItemDef | undefined =>
    ALL_MENU_ITEMS.find(item => item.path === '/' ? pathname === '/' : pathname.startsWith(item.path));

/* ─── Category label map (for sidebar header) ────────────────────────── */
export const CATEGORY_LABELS: Record<string, { label: string; gradient: string }> = {
    overview: { label: 'Overview', gradient: 'linear-gradient(135deg, #667eea, #764ba2)' },
    rides:    { label: 'Ride Operations', gradient: 'linear-gradient(135deg, #f093fb, #f5576c)' },
    fleet:    { label: 'Fleet & Drivers', gradient: 'linear-gradient(135deg, #4facfe, #00f2fe)' },
    services: { label: 'Services & Rates', gradient: 'linear-gradient(135deg, #f7971e, #ffd200)' },
    users:    { label: 'Users & Support', gradient: 'linear-gradient(135deg, #43e97b, #38f9d7)' },
    finance:  { label: 'Finance', gradient: 'linear-gradient(135deg, #fa709a, #fee140)' },
    growth:     { label: 'Growth & Marketing', gradient: 'linear-gradient(135deg, #a18cd1, #fbc2eb)' },
    system:     { label: 'System & Admin', gradient: 'linear-gradient(135deg, #ffecd2, #fcb69f)' },
    wedding: { label: 'Wedding Car Hire', gradient: 'linear-gradient(135deg, #f6d365, #fda085)' },
    coach: { label: 'Coach & Group Travel', gradient: 'linear-gradient(135deg, #5b86e5, #36d1dc)' },
    billing: { label: 'Billing', gradient: 'linear-gradient(135deg, #11998e, #38ef7d)' },
};
